import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { BusinessContextService } from '../services/business-context.service';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class BusinessGuard implements CanActivate {
  constructor(
    private businessContext: BusinessContextService,
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(): Observable<boolean> | boolean {
    if (!this.businessContext.isMultiBusinessMode) {
      return true;
    }

    if (this.businessContext.isBusinessesLoaded()) {
      return this.finishCheck();
    }

    if (!this.authService.isAuthenticated) {
      return false;
    }

    return this.businessContext.loadBusinessesForCurrentUser().pipe(
      map(() => this.finishCheck())
    );
  }

  private finishCheck(): boolean {
    if (this.businessContext.ensureBusinessSelected()) {
      return true;
    }
    this.router.navigate(['/select-business']);
    return false;
  }
}
